export const styles = () => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: 14,
    color: '#3A3F62',
  },
  showItemsBlock: {
    display: 'flex',
    alignItems: 'center',
  },
  select: {
    marginLeft: 16,
    width: 98,
    borderRadius: 10,
  },
  pages: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 24,

    '& button': {
      background: 'transparent',
      border: 0,
      cursor: 'pointer',

      '&:hover svg path': {
        stroke: '#1658F3',
      },
      '&:disabled:hover svg path': {
        stroke: '#B0B2C0',
      },

      '&:disabled': {
        cursor: 'default',
      },
    },
    '& input': {
      margin: '0 8px',
      fontSize: 14,
      color: '#1658F3',
      borderRadius: 10,
      width: 38,
      height: 38,
      border: '1px solid #D7D8DF',
      textAlign: 'center',
      '-moz-appearance': 'textfield',
      '&::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },
      '&::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },
    },

    '& p': {
      margin: '0 8px',
    },
  },
})
